import React, { useEffect, useRef, useState } from "react";
import { MetaTags } from "react-meta-tags";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import { Button, Card, CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { BUSINESS_EMAIL_TEMPLATES_FIELDS } from "../../constants/BusinessEmailTemplatesConstant";
import { generateDateField, generateInputField } from "../../helpers/form_helper";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";

import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

import "./EmailTemplateManagement.scss";
import { generateSelectField } from "../../helpers/form_helper_old";
import { MockInvoiceTypeData } from "./mock-invoice-type-data";
import { EmailTemplateDataFields } from "../../constants/email-template-data-fields";
import { initOptionDateLocale } from "pages/IssueInvoice/utils";
import { MockBusinessEmailTemplateData } from "./mock-business-email-template-data";
import { createBusinessEmailTemplate, getBusinessEmailTemplateDetails, updateBusinessEmailTemplate } from "store/business-email-templates/action";

const BusinessEmailTemplateDetails = (props) => {

  const { t, i18n } = useTranslation(["businessEmailTemplate"]);
  const { action, id } = useParams();

  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const history = useHistory();

  const [listInvoiceType, setListInvoiceType] = useState([]);
  const [listDataFields, setListDataFields] = useState([]);
  const [isDetail, setIsDetail] = useState(false);
  const docEditor = useRef(null);
  const [ckEditorValue, setCkEditorValue] = useState("");
  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const { details: emailDetail } = useSelector(state => state.businessEmailTemplatesData);

  const initControlFields = {
    display: {
      ten: false,
      loai_email: false,
      tieu_de: false,
      noi_dung: false,
      hieu_luc: false,
      ngay_bat_dau: false,
      ngay_ket_thuc: false
    },
  };

  const [controlFields, setControlFields] = useState(initControlFields);

  const schema = yup.object().shape({
    ten: yup.string(),
    loai_email: yup.object(),
    tieu_de: yup.string(),
    noi_dung: yup.string(),
    hieu_luc: yup.boolean(),
    ngay_bat_dau: yup.string(),
    ngay_ket_thuc: yup.string()
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ten: "",
      loai_email: {},
      tieu_de: "",
      noi_dung: "",
      hieu_luc: true,
      ngay_bat_dau: "",
      ngay_ket_thuc: ""
    },
  });

  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  useEffect(() => {
    if (action === "edit") {
      dispatch(getBusinessEmailTemplateDetails(id));
    }
  }, [dispatch, action])

  useEffect(() => {
    if (emailDetail) {
      // setValue("ten", emailDetail.template_code);
      // setValue("loai_email", emailDetail.email_type);
      // setValue("tieu_de", emailDetail.title);
      setCkEditorValue(emailDetail.template_content);
      console.log("ssssssssssssss", ckEditorValue);
      // setValue("hieu_luc", emailDetail.valid);
      // setValue("ngay_bat_dau", emailDetail.date_start);
      // setValue("ngay_ket_thuc", emailDetail.data_end);
    }

  }, [emailDetail])

  const addDataFieldToEditor = (param) => {
    if (docEditor && docEditor.current) {
      const viewFragment = docEditor.current.data.processor.toView(param.value);
      const modelFragment = docEditor.current.data.toModel(viewFragment);
      docEditor.current.model.insertContent(modelFragment);
    }
  }

  const onSubmit = (values) => {
    console.log("ckEditorValue", ckEditorValue);
    console.log("ckEditorValue", values);
    if (action === "create") {
      const emailTemplate = {
        template_code: "TEST",
        template_content: ckEditorValue,
        message_channel_id: 15,
        description: "",
        param_content: [
          {
            field_name: "name",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: "test"
          }
        ],
        param_meta: [
          {
            field_name: "name",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.ten
          },
          {
            field_name: "title",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.tieu_de
          },
          {
            field_name: "email_type",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.loai_email.label
          },
          {
            field_name: "valid",
            field_type: "Boolean",
            field_require: 1,
            description: "mota",
            default_value: values.hieu_luc.toString()
          },
          {
            field_name: "start_date",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.ngay_bat_dau
          },
          {
            field_name: "end_date",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.ngay_ket_thuc
          },
          {
            field_name: "display",
            field_type: "String",
            field_require: 1,
            description: "mota"
          },
          {
            field_name: "subject",
            field_type: "String",
            field_require: 1,
            description: "mota"
          },
          {
            field_name: "to_email",
            field_type: "ArrayEmail",
            field_require: 1,
            description: "mota"
          },
          {
            field_name: "cc",
            field_type: "ArrayEmail",
            field_require: 0,
            description: "mota"
          }
        ]
      };
      dispatch(createBusinessEmailTemplate(emailTemplate))
    } else {
      const emailTemplate = {
        template_code: "TEST",
        template_content: ckEditorValue,
        message_channel_id: 15,
        description: "",
        param_content: [
          {
            field_name: "name",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: "test"
          }
        ],
        param_meta: [
          {
            field_name: "name",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.ten
          },
          {
            field_name: "title",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.tieu_de
          },
          {
            field_name: "email_type",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.loai_email.label
          },
          {
            field_name: "valid",
            field_type: "Boolean",
            field_require: 1,
            description: "mota",
            default_value: values.hieu_luc.toString()
          },
          {
            field_name: "start_date",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.ngay_bat_dau
          },
          {
            field_name: "end_date",
            field_type: "String",
            field_require: 1,
            description: "mota",
            default_value: values.ngay_ket_thuc
          },
          {
            field_name: "display",
            field_type: "String",
            field_require: 1,
            description: "mota"
          },
          {
            field_name: "subject",
            field_type: "String",
            field_require: 1,
            description: "mota"
          },
          {
            field_name: "to_email",
            field_type: "ArrayEmail",
            field_require: 1,
            description: "mota"
          },
          {
            field_name: "cc",
            field_type: "ArrayEmail",
            field_require: 0,
            description: "mota"
          }
        ]
      };
      dispatch(updateBusinessEmailTemplate(id, emailTemplate))
    }

  };

  useEffect(() => {
    setListInvoiceType(MockInvoiceTypeData);
    setListDataFields(EmailTemplateDataFields);
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{action === "create" ? t("title.create") : t("title.edit")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={action === "create" ? t("title.create") : t("title.edit")}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <FormGroup className="mb-2">
                        {generateInputField(
                          t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.NAME.translate}`),
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.NAME.required,
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.NAME.type,
                          errors,
                          touchedFields,
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.NAME.field,
                          t("placeholder.enter", {
                            title: t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.NAME.field}`)
                          }),
                          register,
                          false
                        )}
                      </FormGroup>
                    </Col>
                    <Col>
                      {generateSelectField(
                        t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.EMAIL_TYPE.translate}`),
                        true,
                        errors,
                        BUSINESS_EMAIL_TEMPLATES_FIELDS.EMAIL_TYPE.field,
                        t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.EMAIL_TYPE.translate}`),
                        false,
                        control,
                        listInvoiceType,
                        "auto",
                        () => {

                        },
                        false
                      )}
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <FormGroup className="mb-2">
                        {generateInputField(
                          t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.TITLE.translate}`),
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.TITLE.required,
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.TITLE.type,
                          errors,
                          touchedFields,
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.TITLE.field,
                          t("placeholder.enter", {
                            title: t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.TITLE.field}`)
                          }),
                          register,
                          false
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <div className="container-ck-content">
                        <Label htmlFor="content">{t("form.content")} <span className="text-danger"> (*)</span></Label>
                        <CKEditor
                          editor={DecoupledEditor}
                          data={ckEditorValue}
                          name={'content'}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            console.log("data", data);
                            setCkEditorValue(data)
                          }}
                          onReady={editor => {
                            if (editor) {
                              editor.ui
                                .getEditableElement()
                                .parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.getEditableElement()
                              );
                              docEditor.current = editor;
                              if (ckEditorValue) {
                                docEditor.current.setData(ckEditorValue);
                              }
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-4 data-fields">
                    {t(`form.data_fields`)}
                    <div className="mx-3">
                      {
                        listDataFields.map(dataField => (
                          <div className="mb-1" key={dataField.value} onClick={() => addDataFieldToEditor(dataField)}>
                            <span>{dataField.value}</span> <span>{dataField.description}</span>
                          </div>
                        ))
                      }
                    </div>
                  </Row>
                  <Row className="mt-4 mb-2">
                    <Col>
                      <FormGroup className="mb-2">
                        <Label style={{ cursor: "pointer" }}
                               className="d-flex align-items-center gap-1">
                          <input
                            {...register("hieu_luc")}
                            type="checkbox"
                            onChange={(event) => console.log(event)}
                          />
                          {t("form.valid")}
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="mb-2">
                        {generateDateField(
                          t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.START_DATE.translate}`),
                          "",
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.START_DATE.required,
                          errors,
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.START_DATE.field,
                          "DD/MM/YY",
                          false,
                          control,
                          optionDateLocale
                        )}
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="mb-2">
                        {generateDateField(
                          t(`form.${BUSINESS_EMAIL_TEMPLATES_FIELDS.END_DATE.translate}`),
                          "",
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.END_DATE.required,
                          errors,
                          BUSINESS_EMAIL_TEMPLATES_FIELDS.END_DATE.field,
                          "DD/MM/YY",
                          false,
                          control,
                          optionDateLocale
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-end">
            <Col className="col-auto">
              <Link
                to="/business-email-templates"
                className="btn btn-danger btn-label"
              >
                <i className="fas fa-undo label-icon" />
                {t("form.cancel")}
              </Link>
            </Col>
            <Col className="col-auto">
              {/*<Button*/}
              {/*  color="primary"*/}
              {/*  className="btn-label"*/}
              {/*  type="button"*/}
              {/*  onClick={() => {*/}
              {/*    handleSubmit(onSubmit)();*/}
              {/*  }}*/}
              {/*  disabled={loadingCreate}*/}
              {/*>*/}
              {/*  <i className="far fa-save label-icon" />*/}
              {/*  {t("form.save")}*/}
              {/*</Button>*/}
              <Link
                to="/business-email-templates"
                className="btn btn-primary btn-label"
                onClick={handleSubmit(onSubmit)}
              >
                <i className="far fa-save label-icon" />
                {t("form.save")}
              </Link>

            </Col>
          </Row>

        </div>
      </div>
    </React.Fragment>
  )
}

export default BusinessEmailTemplateDetails;
